export default "/images/061a29c0ba03b72f4f1b5b4818126704.avif";